<template>
    <div class="modal-card large">
        <div class="modal-card-head">
            <div class="modal-card-title">Select up to 50 aircraft for charting comparisons</div>
            <div class="modal-close-button" @click="$emit('close')"></div>
        </div>
        <div class="modal-card-body">
            <div class="mx-4 my-4">
                <div class="columns">
                    <div class="column">
                        <Search @updateAircraft="aircraft = $event" :PortfolioId="PortfolioId"></Search>
                        <br /><br />
                        <div v-if="aircraft.length > 0">
                            <AircraftTable :Aircraft="aircraft"
                                           Select
                                           Name
                                           Model
                                           ForChart
                                           @addSelected="selectAircraftForCharting($event)">
                            </AircraftTable>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AircraftTable from "@/components/aircraft/aircraftTable.vue";
    import Search from "@/components/aircraft/search.vue";
    export default {
        components: {
            AircraftTable,
            Search
        },
        props: {
            PortfolioId: String
        },
        data() {
            return {
                aircraft: []
            }
        },
        methods: {
            selectAircraftForCharting(aircraftIds) {
                this.$emit("selectAircraft", aircraftIds);
                this.$parent.close();
            }
        }
    }
</script>